export default __webpack_public_path__ + "static/media/marauders-map-v0-01-01.07a1de89.jpg";